import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { mfa } from "../../../utils/securityService";
import MfaSetup from "../../security/mfaSetup";

/** My Account → Two-step sign-in (Nov 2026): status, and set it up (or move it to a new phone). */
const TwoStepTab = () => {
  const [status, setStatus] = useState(null);
  const [setting, setSetting] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    const res = await mfa({ action: "status" }, { signedIn: true });
    if (res.ok) setStatus(res.data); else setError(res.message);
  };
  useEffect(() => { load(); }, []);

  if (!status && !error) return <CircularProgress sx={{ m: 4 }} />;
  const on = status?.enabled?.length > 0;
  const label = { app: "an authenticator app", sms: "text message" }[status?.preferred] || "on";

  return (
    <Box sx={{ px: "32px", mt: 3, mb: 4 }}>
      <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 1 }}>Two-step sign-in</Typography>
      <Typography sx={{ fontSize: 14, mb: 2, maxWidth: 640 }}>
        After your password, you'll enter a 6-digit code from your phone. This keeps student information safe even
        if someone learns your password.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {status && (
        <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 2 }}>
          {on ? `On — using ${label}.` : status.required ? "Not set up yet (required for all staff)." : "Off."}
        </Typography>
      )}
      {status && !setting && (
        <Box>
          <Button variant={on ? "outlined" : "contained"} onClick={() => setSetting(true)} sx={{ textTransform: "none" }}>
            {on ? "Move to a new phone or app" : "Set up two-step sign-in"}
          </Button>
          {!on && (
            <Typography sx={{ fontSize: 13, mt: 1, maxWidth: 640 }}>
              If you also use the DiscloSure responder app, make sure it's updated to the latest version first.
            </Typography>
          )}
        </Box>
      )}
      {setting && (
        <MfaSetup signedIn smsAvailable={status?.smsAvailable}
                  onDone={() => { setSetting(false); load(); }} />
      )}
    </Box>
  );
};

export default TwoStepTab;
